var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.requests.length)?_c('div',{staticClass:"requests",on:{"click":_vm.openManageRequestsPage}},[_c('icon-question',{attrs:{"height":"40","width":"40","iconColor":"#fff"}}),_c('div',{staticClass:"requests-amount",class:_vm.amountClasses},[_vm._v("\n    "+_vm._s(_vm.requestsAmount)+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }